import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { notification } from "antd";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { Login } from "./pages/login";
import { MyAccount } from "./pages/myAccount";
import { Layout } from "./components/layout";
import { Tenants } from "./pages/tenants";
import { Applications } from "./pages/applications";
import { SignedIn } from "./pages/signedIn";
import { PrivateRoute } from "./components/privateRoute";
import { NoMatch } from "./components/noMatch";
import { Loading } from "./components/loading";
import roles from "./constants/roles";
import { setUser } from "./pages/actions";
import { User } from "./types/user";
import "./i18n";

export const history = createBrowserHistory();

notification.config({
  maxCount: 1,
});

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      setIsLoading(false);
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/Identity/user/token/refresh`, { refreshToken })
      .then((res) => {
        const user: User = jwtDecode(res.data.accessToken);
        user.role = user["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        user.permissions = user.Permission;
        dispatch(setUser(user));
        setIsLoading(false);
      })
      .catch((_) => {
        setIsLoading(false);
      });
  }, [dispatch]);

  return isLoading ? (
    <Loading />
  ) : (
    <HistoryRouter history={history}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            path="/"
            element={<PrivateRoute roles={[roles.ADMINISTRATOR, roles.APPLICATION, roles.SALES_MANAGER]} />}
          >
            <Route index element={<Tenants />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/my-account" element={<MyAccount />} />
          </Route>
          <Route path="/" element={<PrivateRoute roles={[roles.ADMINISTRATOR, roles.APPLICATION]} />}>
            <Route path="/applications" element={<Applications />} />
          </Route>
          <Route path="/signedIn" element={<SignedIn />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </HistoryRouter>
  );
}

export default App;
